<app-chip-filters *ngIf="installationsAmount > 0">
  <app-chip-filter
    data-at-filter="all"
    gtm="onSetFilter"
    gtmAction="All installations"
    gtmCategory="installationsOverview"
    [active]="activeFilter === installationsFilterType.All"
    [count]="installationsAmount"
    (click)="filterInstallations(installationsFilterType.All)"
  >
    {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.ALL' | translate }}
  </app-chip-filter>
  <app-chip-filter
    data-at-filter="working"
    *ngIf="workingAmount"
    gtm="onSetFilter"
    gtmAction="Working installations"
    gtmCategory="installationsOverview"
    icon="check_circle"
    iconStyle="green"
    [active]="activeFilter === installationsFilterType.Working"
    [count]="workingAmount"
    (click)="filterInstallations(installationsFilterType.Working)"
  >
    {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.WORKING' | translate }}
  </app-chip-filter>
  <app-chip-filter
    data-at-filter="coldSystem"
    *ngIf="coldSystemAmount"
    gtm="onSetFilter"
    gtmAction="Cold system installations"
    gtmCategory="installationsOverview"
    icon="cancel"
    iconStyle="red"
    [active]="activeFilter === installationsFilterType.ColdSystem"
    [count]="coldSystemAmount"
    (click)="filterInstallations(installationsFilterType.ColdSystem)"
  >
    {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.COLD_SYSTEM' | translate }}
  </app-chip-filter>
  <app-chip-filter
    data-at-filter="error"
    *ngIf="errorsAmount"
    gtm="onSetFilter"
    gtmAction="Error installations"
    gtmCategory="installationsOverview"
    icon="error"
    iconStyle="yellow"
    [active]="activeFilter === installationsFilterType.Error"
    [count]="errorsAmount"
    (click)="filterInstallations(installationsFilterType.Error)"
  >
    <span *ngIf="errorsAmount === 1">{{
      '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.FAULT' | translate
    }}</span>
    <span *ngIf="errorsAmount > 1">{{
      '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.FAULTS' | translate
    }}</span>
  </app-chip-filter>
  <app-chip-filter
    data-at-filter="maintenance"
    *ngIf="maintenanceAmount"
    gtm="onSetFilter"
    gtmAction="Maintenance installations"
    gtmCategory="installationsOverview"
    icon="build"
    iconStyle="blue"
    [active]="activeFilter === installationsFilterType.Maintenance"
    [count]="maintenanceAmount"
    (click)="filterInstallations(installationsFilterType.Maintenance)"
  >
    {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.MAINTENANCE' | translate }}
  </app-chip-filter>
  <app-chip-filter
    data-at-filter="offline"
    *ngIf="offlineAmount"
    gtm="onSetFilter"
    gtmAction="Offline installations"
    gtmCategory="installationsOverview"
    icon="wifi_off"
    iconStyle="grey"
    [active]="activeFilter === installationsFilterType.Offline"
    [count]="offlineAmount"
    (click)="filterInstallations(installationsFilterType.Offline)"
  >
    {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.OFFLINE' | translate }}
  </app-chip-filter>
  <app-chip-filter
    data-at-filter="remoteDiagnostic"
    *ngIf="remoteDiagnosticAmount"
    gtm="onSetFilter"
    gtmAction="Diagnostic installations"
    gtmCategory="installationsOverview"
    icon="timeline"
    iconStyle="blue"
    [active]="activeFilter === installationsFilterType.RemoteDiagnostic"
    [count]="remoteDiagnosticAmount"
    (click)="filterInstallations(installationsFilterType.RemoteDiagnostic)"
  >
    {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.REMOTE_DIAGNOSTIC' | translate }}
  </app-chip-filter>
</app-chip-filters>
